import { ServiceOrder } from '@mews-commander/data-access';
import { ExpandableList } from '@optimus-web/core';
import { ServiceOrderItem } from '../ServiceOrderItem';

interface ServiceListProps {
    serviceOrders: ServiceOrder[];
    billId: string;
    accountId: string;
    month: string;
    depth?: number;
}

export const MonthServiceList: React.FC<ServiceListProps> = ({
    serviceOrders,
    billId,
    accountId,
    month,
    depth = 0,
}) => (
    <ExpandableList multiSelect depth={depth}>
        {serviceOrders.map(({ id, serviceId }) => (
            <ServiceOrderItem
                key={id}
                value={id}
                serviceOrderId={id}
                billId={billId}
                accountId={accountId}
                serviceId={serviceId}
                depth={depth + 1}
                month={month}
                isRebateScreen={false}
            />
        ))}
    </ExpandableList>
);
